import { FC } from 'react';
import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import Button from 'src/components/Button';
import useStartMatch from 'src/hooks/useStartMatch';
import { closeModalAtom } from 'src/stores/modal/atoms';
import { ModalType } from 'src/types/Modal';
import { WithTestId } from 'src/types/utils';
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;
type Props = WithTestId<{
  onStartMatch?: () => void;
  className?: string;
}>;
const PreferenceSaveButtons: FC<Props> = ({
  onStartMatch,
  ...props
}) => {
  const {
    t
  } = useTranslation();
  const closeModal = useSetAtom(closeModalAtom);
  const {
    startMatch,
    canStartMatch
  } = useStartMatch();
  const handleClickSaveAndStart = () => {
    closeModal(ModalType.MATCH_SETTING);
    if (canStartMatch) {
      onStartMatch?.();
      startMatch();
    }
  };
  return <Wrap {...props} data-sentry-element="Wrap" data-sentry-component="PreferenceSaveButtons" data-sentry-source-file="PreferenceSaveButtons.tsx">
      <Button id='FILTER_SAVE_AND_START' onClick={handleClickSaveAndStart} data-testid='Preference-save-and-start' data-sentry-element="Button" data-sentry-source-file="PreferenceSaveButtons.tsx">
        {t('vividi_genderfilter_btn_gotomatch')}
      </Button>
    </Wrap>;
};
export default PreferenceSaveButtons;